"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const helpler_1 = require("../../utils/helpler");
const scale_1 = require("../../utils/scale");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const { width } = react_native_1.Dimensions.get('window');
const ModalUnFollow = (props) => {
    const { visible, onClose, modalPosition, hashTag, openModalNoti } = props;
    return (react_1.default.createElement(react_native_1.Modal, { visible: visible, animationType: "none", statusBarTranslucent: true, transparent: true, onRequestClose: onClose, onShow: () => {
            helpler_1.isWeb && document.body.classList.add("prevent-slice-modal");
        }, onDismiss: () => {
            helpler_1.isWeb && document.body.classList.remove("prevent-slice-modal");
        }, ...props },
        react_1.default.createElement(react_native_1.TouchableOpacity, { activeOpacity: 1, style: styles.viewContain, onPress: onClose },
            react_1.default.createElement(react_native_1.View, { style: [
                    styles.viewModal,
                    {
                        position: "absolute",
                        top: modalPosition.y + (0, scale_1.scale)(4),
                        right: width - modalPosition.x
                    },
                ] },
                react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles.viewLine, onPress: openModalNoti },
                    react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, style: styles.textNote }, hashTag),
                    react_1.default.createElement(CustomText_1.default, { style: styles.textNote }, 'フォローを解除'))))));
};
const styles = react_native_1.StyleSheet.create({
    viewLine: {
        flex: 1,
        paddingHorizontal: (0, scale_1.scale)(16),
        paddingVertical: (0, scale_1.scale)(8),
    },
    textNote: {
        color: "#D32F2F",
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
    },
    viewModal: {
        backgroundColor: "#DDDDDD",
        // width: scale(130),
        maxWidth: '100%',
        borderRadius: (0, scale_1.scale)(3),
    },
    viewContain: {
        flex: 1,
    },
});
exports.default = ModalUnFollow;
